export default function getResource(label, vars = []) {
    const resources = {
        ends: `Prend fin ${vars[0]}`,
        apply: 'Appliquer dans le panier',
        off: 'de réduction',
        rougeRewards: 'Récompenses Rouge',
        rougeRewardsAreNonrefundable: 'Les récompenses Rouge ne sont pas remboursables. Toute récompense restante après l’échange de cet achat sera perdue.',
        youCanNowApply: 'Vous pouvez maintenant appliquer des récompenses Rouge à votre achat jusqu’à concurrence de',
        availableRewards: 'Récompenses disponibles',
        usePromoCode: `Utiliser le code promotionnel *${vars[0]}* en magasin`,
        toUseYourRewards: 'Pour utiliser vos récompenses en magasin, remettre le code promotionnel suivant à la caisse :',
        viewLess: 'En voir moins',
        viewMore: 'En voir plus',
        storeRedemption: 'Échange en magasin',
        expires: `Expiration ${vars[0]}`
    };
    return resources[label];
}
